import { Navigate, useParams, useSearchParams } from 'react-router';
import { WIDGET_PARAM } from '@/features/agent-builder';
import { useWidgetDefinition } from '@/entities/widget-definition';
import { ROUTES } from '@/shared/config/routes';

/** The agent a widget's old address was opened from, as links to it named it. */
// eslint-disable-next-line i18next/no-literal-string -- a URL parameter, not copy
const AGENT_PARAM = 'agent';

/**
 * A widget's own address, from before widgets were built on the agent's page: it opens the Widgets
 * view of the agent it came from, or of an agent that shows it, or the Tools list for neither.
 */
export function WidgetRedirect() {
  const { widgetId = '' } = useParams<{ widgetId: string }>();
  const [search] = useSearchParams();
  const named = search.get(AGENT_PARAM);
  const widget = useWidgetDefinition(named ? undefined : widgetId);

  const agentId = named ?? widget.data?.usedBy[0]?.id;
  if (agentId) {
    const query = new URLSearchParams({ [WIDGET_PARAM]: widgetId });
    return <Navigate replace to={`${ROUTES.ADMIN_EDIT_AGENT(agentId)}?${query.toString()}`} />;
  }
  if (widget.isPending && !named) return null;
  return <Navigate replace to={ROUTES.ADMIN_TOOLS} />;
}
